'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable max-lines */
// TODO rerite to ts


var _store = require('store');

var _store2 = _interopRequireDefault(_store);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DirectAdd singleton class for work with bronto backend endpoint
 */
var DirectAdd = function () {

    /**
     * Special method for creating and initializing an object created within a class.
     * @return {object} - DirectAdd
     */
    function DirectAdd() {
        var _this = this;

        _classCallCheck(this, DirectAdd);

        this.isDataChanged = function () {
            return _this.isChanged;
        };

        this.createBrontoImg = function (url) {
            // eslint-disable-line max-statements
            var imgId = 'direct-update';
            var img = document.getElementById(imgId);
            var body = document.querySelector('body');

            if (img) {
                img.setAttribute('src', url);
            } else {
                var newImg = new Image(0, 0);
                newImg.src = url;
                newImg.setAttribute('id', imgId);
                /* istanbul ignore next */
                if (body) body.appendChild(newImg);
            }
        };

        this.dateToBrontoDate = function (date) {
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();

            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }
            return month + '/' + day + '/' + year;
        };

        this.getUrlParams = function () {
            var getParams = decodeURI(location.search).slice(1).split('&');
            var params = {};

            getParams.forEach(function (item) {
                var arr = item.split('=');
                if (arr.length < 2) return;
                params[arr[0]] = arr[1];
            });

            return params;
        };

        this.brontoDateToDate = function (brontoDate) {
            var dateArray = brontoDate.split('/');
            var year = parseInt(dateArray[2], 10);
            var month = parseInt(dateArray[0], 10) - 1;
            var day = parseInt(dateArray[1], 10);
            return new Date(year, month, day, 0, 0, 0, 0);
        };

        this.getAffiliate = function () {
            return _this.get('affid') || '';
        };

        this.keys = function () {
            return Object.keys(_store2.default.get(_this.storageName));
        };

        this.get = function (key) {
            return _store2.default.get(_this.storageName)[key];
        };

        this.getAll = function () {
            return _store2.default.get(_this.storageName);
        };

        if (!DirectAdd.instance) {
            this.setDefaultParams();
            this.setFromSearchParam();

            DirectAdd.instance = this;
        }

        return DirectAdd.instance;
    }

    /**
     * Set default bronto params
     */


    _createClass(DirectAdd, [{
        key: 'setDefaultParams',
        value: function setDefaultParams() {
            this.key = '';
            this.isChanged = false;
            this.aliasVariableArray = [['mens-eyeglasses', 'viewed_men'], ['men', 'viewed_men'], ['womens-eyeglasses', 'viewed_women'], ['women', 'viewed_women'], ['full-frames', 'viewed_full_frame'], ['full_name', 'viewed_full_frame'], ['designer-glasses', 'viewed_designer'], ['sports-glasses', 'viewed_sports'], ['prescription-sunglasses', 'viewed_sunglasses'], ['discounted-eyeglasses', 'viewed_clearance'], ['clearance', 'viewed_clearance'], ['progressive-lenses', 'viewed_multifocal'], ['bifocal_progressive', 'viewed_multifocal'], ['computer-glasses', 'viewed_computer']];
            this.storageName = 'DirectAdd';

            if (!_store2.default.get(this.storageName)) {
                _store2.default.set(this.storageName, {});
            }
        }

        /**
         * Set custom name for local storage
         *
         * @param {string} name - storage name
         */

    }, {
        key: 'setStorageName',
        value: function setStorageName(name) {
            this.storageName = name;
            _store2.default.set(this.storageName, {});
        }

        /**
         * Set new aliasVariableArray
         *
         * @param {array} arr - new array for checking category
         * @returns {DirectAdd} - this object
         */

    }, {
        key: 'setAliasVariableArray',
        value: function setAliasVariableArray(arr) {
            this.aliasVariableArray = arr;
            return this;
        }

        /**
         * Returns true if data was changed
         *
         * @returns {Boolean} - is data changed
         */

    }, {
        key: 'saveData',


        /**
         * Save all data to bronto
         * @returns {object} - this object
         */
        value: function saveData() {
            if (!this.isDataChanged() || !this.key) {
                return this;
            }

            this.isChanged = false;
            var brontoUrl = this.createBrontoUrl();
            this.createBrontoImg(brontoUrl);

            return this;
        }

        /**
         * Send report to bronto
         */

    }, {
        key: 'sendBrontoReport',
        value: function sendBrontoReport() {
            var buildData = this.getAll();
            if (this.get('email')) {
                _axios2.default.post('/directbronto/gate/report', (0, _helpers.convertToFormData)(buildData));
            }
        }

        /**
         * Create url for bronto img
         * @returns {object} - this object
         */

    }, {
        key: 'createBrontoUrl',
        value: function createBrontoUrl() {
            var buildData = this.getAll();
            var specificKeys = ['email', 'mobileNumber', 'smsKeywordID1'];
            var email = buildData.email || '';
            var method = email ? 'Add' : 'Update';
            var url = 'https://app.bronto.com/public/?q=direct_' + method.toLowerCase() + '&fn=Public_Direct' + method + 'Form&id=' + this.key + '&transactional=1';

            Object.keys(buildData).forEach(function (key) {
                if (specificKeys.indexOf(key) !== -1) {
                    url = url + '&' + key + '=' + String(buildData[key]);
                }
            });

            Object.keys(buildData).forEach(function (key, i) {
                if (specificKeys.indexOf(key) !== -1) return;
                url = url + '&field' + (i + 1) + '=' + key + ',set,' + buildData[key];
            });

            return url;
        }

        /**
         * Create url for bronto img
         * @param {string} url - for bronto img src
         */


        /**
         * Convert javascript Date object to bronto`s date string format
         *
         * Format: mm/dd/yyyy
         *
         * @param {Date} date - JavaScript Date instance
         * @returns {String} - date
         */

    }, {
        key: 'setFromSearchParam',


        /**
         * Check url search param and get 'affid' and "utm_source', 'utm_medium'
         * Then set 'affid' and 'first_source_medium', 'last_source_medium'
         * @returns {DirectAdd} - this object
         */
        value: function setFromSearchParam() {
            var _getUrlParams = this.getUrlParams(),
                affid = _getUrlParams.affid,
                utmSource = _getUrlParams.utm_source,
                utmMedium = _getUrlParams.utm_medium;

            if (typeof affid !== 'undefined') {
                this.setAffiliate(affid);
            }

            if (typeof utmSource !== 'undefined' && typeof utmMedium !== 'undefined') {
                this.setSourceMedium(utmSource + '/' + utmMedium);
            }
            return this;
        }

        /**
         * Parse url params and return object
         * @return {object} - url params
         */


        /**
         * Convert bronto`s date to javascript Date object
         *
         * @param {string} brontoDate - brontoDate format
         * @returns {string} - normal JavaScript Date instance
         */

    }, {
        key: 'setSourceMedium',


        /**
         * Set last SourceMedium value in storage
         * Also it sets first SourceMedium value if it is empty
         *
         * @param {string} value - source/medium
         * @returns {DirectAdd} - this object
         */
        value: function setSourceMedium(value) {
            this.set('last_source_medium', value);
            if (!this.get('first_source_medium')) {
                this.set('first_source_medium', value);
            }
            return this;
        }

        /**
         * Set affiliate value in storage
         * Also it sets first_affid value if it is empty
         *
         * @param {string} value - affiliate id
         * @returns {DirectAdd} - this object
         */

    }, {
        key: 'setAffiliate',
        value: function setAffiliate(value) {
            this.set('affid', value);
            this.set('last_affid', value);

            if (!this.get('first_affid')) {
                this.set('first_affid', value);
            }
            return this;
        }

        /**
         * Get affiliate value from storage
         *
         * @returns {string} - affiliate
         */

    }, {
        key: 'setBrontoKey',


        /**
         * Set bronto key
         *
         * @param {string} key - bronto key
         * @returns {DirectAdd} - this object
         */
        value: function setBrontoKey(key) {
            this.key = key;
            return this;
        }

        /**
         * Set current category
         *
         * @returns {DirectAdd} - this object
         */

    }, {
        key: 'setCategory',
        value: function setCategory() {
            var category = this.aliasVariableArray.find(function (item) {
                return location.pathname.substr(1) === item[0];
            });
            if (typeof category === 'undefined') return this;
            this.set(category[1], this.dateToBrontoDate(new Date()));
            return this;
        }

        /**
         * Set current visit date
         * date is in bronto format mm\dd\yyyy
         *
         * @param {String} date - current visit date
         * @returns {DirectAdd} - this object
         */

    }, {
        key: 'setCurrentVisitDate',
        value: function setCurrentVisitDate(date) {
            this.set('curr_visit', String(date));
            return this;
        }

        /**
         * Get current visit date
         * Returns date in bronto format as string
         *
         * @returns {String} - JavaScript Date instance
         */

    }, {
        key: 'getCurrentVisitDate',
        value: function getCurrentVisitDate() {
            if (!this.get('curr_visit')) {
                return this.dateToBrontoDate(new Date());
            }
            return this.get('curr_visit');
        }

        /**
         * Set last visit date
         * date - date string in bronto format mm/dd/yyyy
         *
         * @param {String} date - JavaScript Date instance
         * @returns {DirectAdd} - this object
         */

    }, {
        key: 'setLastVisitDate',
        value: function setLastVisitDate(date) {
            this.set('last_visit', String(date));
            return this;
        }

        /**
         * Get last visit date
         * Returns date in bronto format mm/dd/yyyy
         *
         * @returns {String} - last visit date
         */

    }, {
        key: 'getLastVisitDate',
        value: function getLastVisitDate() {
            if (!this.get('last_visit')) {
                return this.getCurrentVisitDate();
            }
            return this.get('last_visit');
        }

        /**
         * Get keys from localStorage
         *
         * @returns {Array} - array of keys
         */

    }, {
        key: 'set',


        /**
         * Set variable in local storage
         *
         * @param {string} key - key property to set data at store
         * @param {string} value - data to save
         * @returns {DirectAdd} - this object
         */
        value: function set(key, value) {
            var data = _store2.default.get(this.storageName);
            if (data[key] !== value) {
                this.isChanged = true;
                data[key] = value;
                _store2.default.set(this.storageName, data);
            }
            return this;
        }

        /**
         * Returns data from local storage
         *
         * @param {string} key - key property to get from store
         * @returns {mixed} - data from store
         */


        /**
         * Returns all DirectAdd data from local storage in one Object
         *
         * @returns {object} - object with all data
         */

    }, {
        key: 'unset',


        /**
         * Unset data in local storage using key
         *
         * @param {string} key - key property to delete from store
         * @returns {DirectAdd} - this object
         */
        value: function unset(key) {
            var data = _store2.default.get(this.storageName);
            if (typeof data[key] === 'undefined') return this;
            this.isChanged = true;
            delete data[key];
            _store2.default.set(this.storageName, data);
            return this;
        }

        /**
         * Clear all data in local storage
         *
         * @returns {DirectAdd} - this object
         */

    }, {
        key: 'clear',
        value: function clear() {
            this.isChanged = true;
            _store2.default.set(this.storageName, {});
            return this;
        }
    }]);

    return DirectAdd;
}();

var instance = new DirectAdd();

exports.default = instance;